import {
  FETCH_PROFILE_ERROR,
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_RECEIVED,
} from "../actions/profile.js";

const defaultState = {
  isLoading: false,
  data: {},
  fetchError: "",
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchError: "",
      };

    case FETCH_PROFILE_RECEIVED:
      return {
        ...state,
        data: action.data,
        isLoading: false,
        fetchError: "",
      };

    case FETCH_PROFILE_ERROR:
      return {
        ...state,
        fetchError: action.error,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default reducer;
